import './chunk-5JBD5THX.js';
import React from 'react';

var IconMap = {
  Adventure: React.lazy(() => import('./category/adventure/Adventure.js')),
  BungeeJumping: React.lazy(() => import('./category/adventure/BungeeJumping.js')),
  Canyoning: React.lazy(() => import('./category/adventure/Canyoning.js')),
  Climbing: React.lazy(() => import('./category/adventure/Climbing.js')),
  GoKart: React.lazy(() => import('./category/adventure/GoKart.js')),
  IndoorAdventure: React.lazy(() => import('./category/adventure/IndoorAdventure.js')),
  OutdoorActivities: React.lazy(() => import('./category/adventure/OutdoorActivities.js')),
  Racing: React.lazy(() => import('./category/adventure/Racing.js')),
  Sandboarding: React.lazy(() => import('./category/adventure/Sandboarding.js')),
  ScubaDiving: React.lazy(() => import('./category/adventure/ScubaDiving.js')),
  Skiing: React.lazy(() => import('./category/adventure/Skiing.js')),
  Skydiving: React.lazy(() => import('./category/adventure/Skydiving.js')),
  Sledding: React.lazy(() => import('./category/adventure/Sledding.js')),
  Snowboarding: React.lazy(() => import('./category/adventure/Snowboarding.js')),
  Snowshoeing: React.lazy(() => import('./category/adventure/Snowshoeing.js')),
  Ziplining: React.lazy(() => import('./category/adventure/Ziplining.js')),
  AerialSightseeing: React.lazy(() => import('./category/aerial-sightseeing/AerialSightseeing.js')),
  AirplaneTours: React.lazy(() => import('./category/aerial-sightseeing/AirplaneTours.js')),
  HelicopterTours: React.lazy(() => import('./category/aerial-sightseeing/HelicopterTours.js')),
  HotAirBalloon: React.lazy(() => import('./category/aerial-sightseeing/HotAirBalloon.js')),
  Classes: React.lazy(() => import('./category/classes/Classes.js')),
  DanceClasses: React.lazy(() => import('./category/classes/DanceClasses.js')),
  FitnessClasses: React.lazy(() => import('./category/classes/FitnessClasses.js')),
  PhotographyClasses: React.lazy(() => import('./category/classes/PhotographyClasses.js')),
  Workshops: React.lazy(() => import('./category/classes/Workshops.js')),
  Cruises: React.lazy(() => import('./category/cruises/Cruises.js')),
  EveningCruises: React.lazy(() => import('./category/cruises/EveningCruises.js')),
  SightseeingCruises: React.lazy(() => import('./category/cruises/SightseeingCruises.js')),
  DayTrips: React.lazy(() => import('./category/day-trips/DayTrips.js')),
  NatureEscapes: React.lazy(() => import('./category/day-trips/NatureEscapes.js')),
  NearbyCities: React.lazy(() => import('./category/day-trips/NearbyCities.js')),
  Sightseeing: React.lazy(() => import('./category/day-trips/Sightseeing.js')),
  Ballet: React.lazy(() => import('./category/entertainment/Ballet.js')),
  Cabarets: React.lazy(() => import('./category/entertainment/Cabarets.js')),
  ChurchConcerts: React.lazy(() => import('./category/entertainment/ChurchConcerts.js')),
  Cinema: React.lazy(() => import('./category/entertainment/Cinema.js')),
  Circus: React.lazy(() => import('./category/entertainment/Circus.js')),
  ComedyShows: React.lazy(() => import('./category/entertainment/ComedyShows.js')),
  Concerts: React.lazy(() => import('./category/entertainment/Concerts.js')),
  Dance: React.lazy(() => import('./category/entertainment/Dance.js')),
  Drama: React.lazy(() => import('./category/entertainment/Drama.js')),
  Entertainment: React.lazy(() => import('./category/entertainment/Entertainment.js')),
  Fantasy: React.lazy(() => import('./category/entertainment/Fantasy.js')),
  Kids: React.lazy(() => import('./category/entertainment/Kids.js')),
  MagicShows: React.lazy(() => import('./category/entertainment/MagicShows.js')),
  Musicals: React.lazy(() => import('./category/entertainment/Musicals.js')),
  Nightlife: React.lazy(() => import('./category/entertainment/Nightlife.js')),
  Opera: React.lazy(() => import('./category/entertainment/Opera.js')),
  Pantomime: React.lazy(() => import('./category/entertainment/Pantomime.js')),
  Plays: React.lazy(() => import('./category/entertainment/Plays.js')),
  RecitalConcerts: React.lazy(() => import('./category/entertainment/RecitalConcerts.js')),
  RockConcerts: React.lazy(() => import('./category/entertainment/RockConcerts.js')),
  SeeItInStyle: React.lazy(() => import('./category/entertainment/SeeItInStyle.js')),
  ShowsComingSoon: React.lazy(() => import('./category/entertainment/ShowsComingSoon.js')),
  ShowsReopening: React.lazy(() => import('./category/entertainment/ShowsReopening.js')),
  SpecialsEntertainment: React.lazy(() => import('./category/entertainment/SpecialsEntertainment.js')),
  SportsEntertainment: React.lazy(() => import('./category/entertainment/SportsEntertainment.js')),
  TheatricalConcerts: React.lazy(() => import('./category/entertainment/TheatricalConcerts.js')),
  CoffeeAndTea: React.lazy(() => import('./category/food-and-drinks/CoffeeAndTea.js')),
  CookingClasses: React.lazy(() => import('./category/food-and-drinks/CookingClasses.js')),
  DiningExperiences: React.lazy(() => import('./category/food-and-drinks/DiningExperiences.js')),
  FoodAndDrinks: React.lazy(() => import('./category/food-and-drinks/FoodAndDrinks.js')),
  FoodMenu: React.lazy(() => import('./category/food-and-drinks/FoodMenu.js')),
  FoodPasses: React.lazy(() => import('./category/food-and-drinks/FoodPasses.js')),
  FoodTours: React.lazy(() => import('./category/food-and-drinks/FoodTours.js')),
  PubCrawls: React.lazy(() => import('./category/food-and-drinks/PubCrawls.js')),
  Wineries: React.lazy(() => import('./category/food-and-drinks/Wineries.js')),
  Camping: React.lazy(() => import('./category/nature-and-wildlife/Camping.js')),
  DesertSafari: React.lazy(() => import('./category/nature-and-wildlife/DesertSafari.js')),
  HikingAndTrails: React.lazy(() => import('./category/nature-and-wildlife/HikingAndTrails.js')),
  NationalParks: React.lazy(() => import('./category/nature-and-wildlife/NationalParks.js')),
  NatureAndWildlife: React.lazy(() => import('./category/nature-and-wildlife/NatureAndWildlife.js')),
  Safari: React.lazy(() => import('./category/nature-and-wildlife/Safari.js')),
  CableCar: React.lazy(() => import('./category/rentals/CableCar.js')),
  Campervan: React.lazy(() => import('./category/rentals/Campervan.js')),
  ClassARv: React.lazy(() => import('./category/rentals/ClassARv.js')),
  ClassBRv: React.lazy(() => import('./category/rentals/ClassBRv.js')),
  ClassCRv: React.lazy(() => import('./category/rentals/ClassCRv.js')),
  RvRentals: React.lazy(() => import('./category/rentals/RVRentals.js')),
  Trailers: React.lazy(() => import('./category/rentals/Trailers.js')),
  Combos: React.lazy(() => import('./category/specials/Combos.js')),
  ComingSoon: React.lazy(() => import('./category/specials/ComingSoon.js')),
  DigitalExperiences: React.lazy(() => import('./category/specials/DigitalExperiences.js')),
  Specials: React.lazy(() => import('./category/specials/Specials.js')),
  Baseball: React.lazy(() => import('./category/sports/Baseball.js')),
  Football: React.lazy(() => import('./category/sports/Football.js')),
  MuayThai: React.lazy(() => import('./category/sports/MuayThai.js')),
  Sports: React.lazy(() => import('./category/sports/Sports.js')),
  Beaches: React.lazy(() => import('./category/staycations/Beaches.js')),
  City: React.lazy(() => import('./category/staycations/City.js')),
  MountainExcursions: React.lazy(() => import('./category/staycations/MountainExcursions.js')),
  NationalPark: React.lazy(() => import('./category/staycations/NationalPark.js')),
  Staycations: React.lazy(() => import('./category/staycations/Staycations.js')),
  Wildlife: React.lazy(() => import('./category/staycations/Wildlife.js')),
  Aquarium: React.lazy(() => import('./category/tickets/Aquarium.js')),
  CityPasses: React.lazy(() => import('./category/tickets/CityPasses.js')),
  ImmersiveExperiences: React.lazy(() => import('./category/tickets/ImmersiveExperiences.js')),
  Landmarks: React.lazy(() => import('./category/tickets/Landmarks.js')),
  Museums: React.lazy(() => import('./category/tickets/Museums.js')),
  ObservationDecks: React.lazy(() => import('./category/tickets/ObservationDecks.js')),
  Parks: React.lazy(() => import('./category/tickets/Parks.js')),
  ReligiousSites: React.lazy(() => import('./category/tickets/ReligiousSites.js')),
  ThemeParks: React.lazy(() => import('./category/tickets/ThemeParks.js')),
  Tickets: React.lazy(() => import('./category/tickets/Tickets.js')),
  TrainPasses: React.lazy(() => import('./category/tickets/TrainPasses.js')),
  WaterPark: React.lazy(() => import('./category/tickets/WaterPark.js')),
  ZoosAndAquarium: React.lazy(() => import('./category/tickets/ZoosAndAquarium.js')),
  BikesAndSegway: React.lazy(() => import('./category/tours/BikesAndSegway.js')),
  CityTours: React.lazy(() => import('./category/tours/CityTours.js')),
  GuidedTours: React.lazy(() => import('./category/tours/GuidedTours.js')),
  HohoTours: React.lazy(() => import('./category/tours/HohoTours.js')),
  MultidayTours: React.lazy(() => import('./category/tours/MultidayTours.js')),
  PhotographyTours: React.lazy(() => import('./category/tours/PhotographyTours.js')),
  PortOfCallTours: React.lazy(() => import('./category/tours/PortOfCallTours.js')),
  PrivateTours: React.lazy(() => import('./category/tours/PrivateTours.js')),
  Shopping: React.lazy(() => import('./category/tours/Shopping.js')),
  Tours: React.lazy(() => import('./category/tours/Tours.js')),
  WalkingTours: React.lazy(() => import('./category/tours/WalkingTours.js')),
  AirportTransfers: React.lazy(() => import('./category/transportation/AirportTransfers.js')),
  AttractionTransfers: React.lazy(() => import('./category/transportation/AttractionTransfers.js')),
  CarRentals: React.lazy(() => import('./category/transportation/CarRentals.js')),
  DuneBashing: React.lazy(() => import('./category/transportation/DuneBashing.js')),
  PublicTransport: React.lazy(() => import('./category/transportation/PublicTransport.js')),
  Quadbiking: React.lazy(() => import('./category/transportation/Quadbiking.js')),
  Transportation: React.lazy(() => import('./category/transportation/Transportation.js')),
  TravelInsurance: React.lazy(() => import('./category/travel-services/TravelInsurance.js')),
  TravelServices: React.lazy(() => import('./category/travel-services/TravelServices.js')),
  WifiAndSimCards: React.lazy(() => import('./category/travel-services/WifiAndSimCards.js')),
  BoatRentals: React.lazy(() => import('./category/water-sports/BoatRentals.js')),
  CruiseMeals: React.lazy(() => import('./category/water-sports/CruiseMeals.js')),
  CruiseTickets: React.lazy(() => import('./category/water-sports/CruiseTickets.js')),
  DinnerLunchCruise: React.lazy(() => import('./category/water-sports/DinnerLunchCruise.js')),
  JetSkiing: React.lazy(() => import('./category/water-sports/JetSkiing.js')),
  Kayaking: React.lazy(() => import('./category/water-sports/Kayaking.js')),
  MarineWalk: React.lazy(() => import('./category/water-sports/MarineWalk.js')),
  NatureCruises: React.lazy(() => import('./category/water-sports/NatureCruises.js')),
  PaddleSport: React.lazy(() => import('./category/water-sports/PaddleSport.js')),
  Rafting: React.lazy(() => import('./category/water-sports/Rafting.js')),
  Snorkeling: React.lazy(() => import('./category/water-sports/Snorkeling.js')),
  SpeedBoatTours: React.lazy(() => import('./category/water-sports/SpeedBoatTours.js')),
  Surfing: React.lazy(() => import('./category/water-sports/Surfing.js')),
  WaterSports: React.lazy(() => import('./category/water-sports/WaterSports.js')),
  Waterfall: React.lazy(() => import('./category/water-sports/Waterfall.js')),
  YachtTours: React.lazy(() => import('./category/water-sports/YachtTours.js')),
  Baths: React.lazy(() => import('./category/wellness/Baths.js')),
  FitnessPasses: React.lazy(() => import('./category/wellness/FitnessPasses.js')),
  Spa: React.lazy(() => import('./category/wellness/Spa.js')),
  Wellness: React.lazy(() => import('./category/wellness/Wellness.js')),
  AdventureBooster: React.lazy(() => import('./microbrands/boosters/AdventureBooster.js')),
  AttractionsBooster: React.lazy(() => import('./microbrands/boosters/AttractionsBooster.js')),
  BalletBooster: React.lazy(() => import('./microbrands/boosters/BalletBooster.js')),
  BaseballBooster: React.lazy(() => import('./microbrands/boosters/BaseballBooster.js')),
  BeverageBooster: React.lazy(() => import('./microbrands/boosters/BeverageBooster.js')),
  BoxingGloveBooster: React.lazy(() => import('./microbrands/boosters/BoxingGloveBooster.js')),
  CableCarBooster: React.lazy(() => import('./microbrands/boosters/CableCarBooster.js')),
  CampingBooster: React.lazy(() => import('./microbrands/boosters/CampingBooster.js')),
  CancellationBooster: React.lazy(() => import('./microbrands/boosters/CancellationBooster.js')),
  CartBooster: React.lazy(() => import('./microbrands/boosters/CartBooster.js')),
  ChairBooster: React.lazy(() => import('./microbrands/boosters/ChairBooster.js')),
  ChargingBooster: React.lazy(() => import('./microbrands/boosters/ChargingBooster.js')),
  CheckMarkBooster: React.lazy(() => import('./microbrands/boosters/CheckMarkBooster.js')),
  CityPassesBooster: React.lazy(() => import('./microbrands/boosters/CityPassesBooster.js')),
  ClockBooster: React.lazy(() => import('./microbrands/boosters/ClockBooster.js')),
  CoffeeBeansBooster: React.lazy(() => import('./microbrands/boosters/CoffeeBeansBooster.js')),
  CoffeeBooster: React.lazy(() => import('./microbrands/boosters/CoffeeBooster.js')),
  ColoredHeartBooster: React.lazy(() => import('./microbrands/boosters/ColoredHeartBooster.js')),
  CompassBooster: React.lazy(() => import('./microbrands/boosters/CompassBooster.js')),
  ConcertsBooster: React.lazy(() => import('./microbrands/boosters/ConcertsBooster.js')),
  CostEffectiveBooster: React.lazy(() => import('./microbrands/boosters/CostEffectiveBooster.js')),
  CulinaryBooster: React.lazy(() => import('./microbrands/boosters/CulinaryBooster.js')),
  DesertBooster: React.lazy(() => import('./microbrands/boosters/DesertBooster.js')),
  DinnerCruisesBooster: React.lazy(() => import('./microbrands/boosters/DinnerCruisesBooster.js')),
  FAndBBooster: React.lazy(() => import('./microbrands/boosters/FAndBBooster.js')),
  FamilyBooster: React.lazy(() => import('./microbrands/boosters/FamilyBooster.js')),
  FishBooster: React.lazy(() => import('./microbrands/boosters/FishBooster.js')),
  FitnessBooster: React.lazy(() => import('./microbrands/boosters/FitnessBooster.js')),
  FlagBooster: React.lazy(() => import('./microbrands/boosters/FlagBooster.js')),
  GlobeBooster: React.lazy(() => import('./microbrands/boosters/GlobeBooster.js')),
  GroupBooster: React.lazy(() => import('./microbrands/boosters/GroupBooster.js')),
  HeadphonesBooster: React.lazy(() => import('./microbrands/boosters/HeadphonesBooster.js')),
  HeartRateBooster: React.lazy(() => import('./microbrands/boosters/HeartRateBooster.js')),
  HelicopterBooster: React.lazy(() => import('./microbrands/boosters/HelicopterBooster.js')),
  HotspringBooster: React.lazy(() => import('./microbrands/boosters/HotspringBooster.js')),
  HourglassBooster: React.lazy(() => import('./microbrands/boosters/HourglassBooster.js')),
  ImmersiveBooster: React.lazy(() => import('./microbrands/boosters/ImmersiveBooster.js')),
  InsightsBooster: React.lazy(() => import('./microbrands/boosters/InsightsBooster.js')),
  IslandBooster: React.lazy(() => import('./microbrands/boosters/IslandBooster.js')),
  LandmarksBooster: React.lazy(() => import('./microbrands/boosters/LandmarksBooster.js')),
  LeafBooster: React.lazy(() => import('./microbrands/boosters/LeafBooster.js')),
  LearnerBooster: React.lazy(() => import('./microbrands/boosters/LearnerBooster.js')),
  LocationsBooster: React.lazy(() => import('./microbrands/boosters/LocationsBooster.js')),
  LotusBooster: React.lazy(() => import('./microbrands/boosters/LotusBooster.js')),
  LuxuryBooster: React.lazy(() => import('./microbrands/boosters/LuxuryBooster.js')),
  MapBooster: React.lazy(() => import('./microbrands/boosters/MapBooster.js')),
  MobileTicketBooster: React.lazy(() => import('./microbrands/boosters/MobileTicketBooster.js')),
  MoneyBooster: React.lazy(() => import('./microbrands/boosters/MoneyBooster.js')),
  MountainBooster: React.lazy(() => import('./microbrands/boosters/MountainBooster.js')),
  MultipleCardOptionsBooster: React.lazy(() => import('./microbrands/boosters/MultipleCardOptionsBooster.js')),
  MultipleOptionsBooster: React.lazy(() => import('./microbrands/boosters/MultipleOptionsBooster.js')),
  MusicBooster: React.lazy(() => import('./microbrands/boosters/MusicBooster.js')),
  NightViewBooster: React.lazy(() => import('./microbrands/boosters/NightViewBooster.js')),
  NightlifeBooster: React.lazy(() => import('./microbrands/boosters/NightlifeBooster.js')),
  OceanFloorBooster: React.lazy(() => import('./microbrands/boosters/OceanFloorBooster.js')),
  OpeningBooster: React.lazy(() => import('./microbrands/boosters/OpeningBooster.js')),
  PaddleBooster: React.lazy(() => import('./microbrands/boosters/PaddleBooster.js')),
  PaintBooster: React.lazy(() => import('./microbrands/boosters/PaintBooster.js')),
  PanBooster: React.lazy(() => import('./microbrands/boosters/PanBooster.js')),
  PanaromaBooster: React.lazy(() => import('./microbrands/boosters/PanaromaBooster.js')),
  PeaceBooster: React.lazy(() => import('./microbrands/boosters/PeaceBooster.js')),
  PhotographicBooster: React.lazy(() => import('./microbrands/boosters/PhotographicBooster.js')),
  PlanningBooster: React.lazy(() => import('./microbrands/boosters/PlanningBooster.js')),
  PortOfCallBooster: React.lazy(() => import('./microbrands/boosters/PortOfCallBooster.js')),
  PublicTransportBooster: React.lazy(() => import('./microbrands/boosters/PublicTransportBooster.js')),
  RouteBooster: React.lazy(() => import('./microbrands/boosters/RouteBooster.js')),
  SearchBooster: React.lazy(() => import('./microbrands/boosters/SearchBooster.js')),
  SeatBooster: React.lazy(() => import('./microbrands/boosters/SeatBooster.js')),
  ShoppingBooster: React.lazy(() => import('./microbrands/boosters/ShoppingBooster.js')),
  SightseeingBooster: React.lazy(() => import('./microbrands/boosters/SightseeingBooster.js')),
  SimBooster: React.lazy(() => import('./microbrands/boosters/SimBooster.js')),
  SkipTheLineBooster: React.lazy(() => import('./microbrands/boosters/SkipTheLineBooster.js')),
  SkydivingBooster: React.lazy(() => import('./microbrands/boosters/SkydivingBooster.js')),
  SnorkelingBooster: React.lazy(() => import('./microbrands/boosters/SnorkelingBooster.js')),
  SparklePinBooster: React.lazy(() => import('./microbrands/boosters/SparklePinBooster.js')),
  SparksBooster: React.lazy(() => import('./microbrands/boosters/SparksBooster.js')),
  SpeedBoatBooster: React.lazy(() => import('./microbrands/boosters/SpeedBoatBooster.js')),
  SpeedBooster: React.lazy(() => import('./microbrands/boosters/SpeedBooster.js')),
  StoreBooster: React.lazy(() => import('./microbrands/boosters/StoreBooster.js')),
  SunBooster: React.lazy(() => import('./microbrands/boosters/SunBooster.js')),
  SupportBooster: React.lazy(() => import('./microbrands/boosters/SupportBooster.js')),
  SurfBoardBooster: React.lazy(() => import('./microbrands/boosters/SurfBoardBooster.js')),
  TicketBooster: React.lazy(() => import('./microbrands/boosters/TicketBooster.js')),
  TicketDiscountBooster: React.lazy(() => import('./microbrands/boosters/TicketDiscountBooster.js')),
  ToggleBooster: React.lazy(() => import('./microbrands/boosters/ToggleBooster.js')),
  TransfersBooster: React.lazy(() => import('./microbrands/boosters/TransfersBooster.js')),
  TranslateBooster: React.lazy(() => import('./microbrands/boosters/TranslateBooster.js')),
  TrustedBooster: React.lazy(() => import('./microbrands/boosters/TrustedBooster.js')),
  UserStarBooster: React.lazy(() => import('./microbrands/boosters/UserStarBooster.js')),
  UserTickBooster: React.lazy(() => import('./microbrands/boosters/UserTickBooster.js')),
  VrBooster: React.lazy(() => import('./microbrands/boosters/VRBooster.js')),
  WaterLandmarksBooster: React.lazy(() => import('./microbrands/boosters/WaterLandmarksBooster.js')),
  WhaleBooster: React.lazy(() => import('./microbrands/boosters/WhaleBooster.js')),
  WifiBooster: React.lazy(() => import('./microbrands/boosters/WifiBooster.js')),
  WildlifeBooster: React.lazy(() => import('./microbrands/boosters/WildlifeBooster.js')),
  AdventureMb: React.lazy(() => import('./microbrands/categories/AdventureMb.js')),
  AerialSightseeingMb: React.lazy(() => import('./microbrands/categories/AerialSightseeingMb.js')),
  CruisesMb: React.lazy(() => import('./microbrands/categories/CruisesMb.js')),
  EntertainmentMb: React.lazy(() => import('./microbrands/categories/EntertainmentMb.js')),
  FoodAndDrinksMb: React.lazy(() => import('./microbrands/categories/FoodAndDrinksMb.js')),
  NatureAndWildlifeMb: React.lazy(() => import('./microbrands/categories/NatureAndWildlifeMb.js')),
  PaintMb: React.lazy(() => import('./microbrands/categories/PaintMb.js')),
  PublicTransportMb: React.lazy(() => import('./microbrands/categories/PublicTransportMb.js')),
  SpecialsMb: React.lazy(() => import('./microbrands/categories/SpecialsMb.js')),
  SportsMb: React.lazy(() => import('./microbrands/categories/SportsMb.js')),
  StaycationsMb: React.lazy(() => import('./microbrands/categories/StaycationsMb.js')),
  TicketsMb: React.lazy(() => import('./microbrands/categories/TicketsMb.js')),
  ToursMb: React.lazy(() => import('./microbrands/categories/ToursMb.js')),
  TransportationMb: React.lazy(() => import('./microbrands/categories/TransportationMb.js')),
  TravelServicesMb: React.lazy(() => import('./microbrands/categories/TravelServicesMb.js')),
  WaterSportsMb: React.lazy(() => import('./microbrands/categories/WaterSportsMb.js')),
  WellnessMb: React.lazy(() => import('./microbrands/categories/WellnessMb.js')),
  ArrowCircleDownFilled: React.lazy(() => import('./ui/arrow/fill/ArrowCircleDownFilled.js')),
  ArrowCircleLeftFilled: React.lazy(() => import('./ui/arrow/fill/ArrowCircleLeftFilled.js')),
  ArrowCircleRightFilled: React.lazy(() => import('./ui/arrow/fill/ArrowCircleRightFilled.js')),
  ArrowCircleTopFilled: React.lazy(() => import('./ui/arrow/fill/ArrowCircleTopFilled.js')),
  ArrowCircleDown: React.lazy(() => import('./ui/arrow/stroke/ArrowCircleDown.js')),
  ArrowCircleLeft: React.lazy(() => import('./ui/arrow/stroke/ArrowCircleLeft.js')),
  ArrowCircleRight: React.lazy(() => import('./ui/arrow/stroke/ArrowCircleRight.js')),
  ArrowCircleTop: React.lazy(() => import('./ui/arrow/stroke/ArrowCircleTop.js')),
  ArrowDown: React.lazy(() => import('./ui/arrow/stroke/ArrowDown.js')),
  ArrowLeft: React.lazy(() => import('./ui/arrow/stroke/ArrowLeft.js')),
  ArrowRight: React.lazy(() => import('./ui/arrow/stroke/ArrowRight.js')),
  ArrowTop: React.lazy(() => import('./ui/arrow/stroke/ArrowTop.js')),
  BookmarkFilled: React.lazy(() => import('./ui/bookmarks/fill/BookmarkFilled.js')),
  BookmarkWithTickFilled: React.lazy(() => import('./ui/bookmarks/fill/BookmarkWithTickFilled.js')),
  BookmarkWithTick: React.lazy(() => import('./ui/bookmarks/stroke/BookmarkWithTick.js')),
  Bookmark: React.lazy(() => import('./ui/bookmarks/stroke/Bookmark.js')),
  CheckmarkInsideCircleFilled: React.lazy(() => import('./ui/checkmark/CheckmarkInsideCircleFilled.js')),
  CheckmarkInsideCircle: React.lazy(() => import('./ui/checkmark/CheckmarkInsideCircle.js')),
  CheckmarkWithBox: React.lazy(() => import('./ui/checkmark/CheckmarkWithBox.js')),
  CheckmarkWithCircle: React.lazy(() => import('./ui/checkmark/CheckmarkWithCircle.js')),
  Checkmark: React.lazy(() => import('./ui/checkmark/Checkmark.js')),
  ChevronCircleDownFill: React.lazy(() => import('./ui/chevron/fill/ChevronCircleDownFill.js')),
  ChevronCircleLeftFill: React.lazy(() => import('./ui/chevron/fill/ChevronCircleLeftFill.js')),
  ChevronCircleRightFill: React.lazy(() => import('./ui/chevron/fill/ChevronCircleRightFill.js')),
  ChevronCircleTopFill: React.lazy(() => import('./ui/chevron/fill/ChevronCircleTopFill.js')),
  ChevronCircleDown: React.lazy(() => import('./ui/chevron/stroke/ChevronCircleDown.js')),
  ChevronCircleLeft: React.lazy(() => import('./ui/chevron/stroke/ChevronCircleLeft.js')),
  ChevronCircleRight: React.lazy(() => import('./ui/chevron/stroke/ChevronCircleRight.js')),
  ChevronCircleTop: React.lazy(() => import('./ui/chevron/stroke/ChevronCircleTop.js')),
  ChevronDown: React.lazy(() => import('./ui/chevron/stroke/ChevronDown.js')),
  ChevronLeft: React.lazy(() => import('./ui/chevron/stroke/ChevronLeft.js')),
  ChevronRight: React.lazy(() => import('./ui/chevron/stroke/ChevronRight.js')),
  ChevronTop: React.lazy(() => import('./ui/chevron/stroke/ChevronTop.js')),
  DoubleChevronDown: React.lazy(() => import('./ui/chevron/stroke/DoubleChevronDown.js')),
  DoubleChevronLeft: React.lazy(() => import('./ui/chevron/stroke/DoubleChevronLeft.js')),
  DoubleChevronRight: React.lazy(() => import('./ui/chevron/stroke/DoubleChevronRight.js')),
  DoubleChevronTop: React.lazy(() => import('./ui/chevron/stroke/DoubleChevronTop.js')),
  CrossInCircleFilled: React.lazy(() => import('./ui/cross/CrossInCircleFilled.js')),
  CrossInCircle: React.lazy(() => import('./ui/cross/CrossInCircle.js')),
  Cross: React.lazy(() => import('./ui/cross/Cross.js')),
  AlertCircleFilled: React.lazy(() => import('./ui/fill/AlertCircleFilled.js')),
  AlertTriangleFilled: React.lazy(() => import('./ui/fill/AlertTriangleFilled.js')),
  ArrowSquareFilled: React.lazy(() => import('./ui/fill/ArrowSquareFilled.js')),
  AudioFilled: React.lazy(() => import('./ui/fill/AudioFilled.js')),
  BarFilled: React.lazy(() => import('./ui/fill/BarFilled.js')),
  BarSquareFilled: React.lazy(() => import('./ui/fill/BarSquareFilled.js')),
  BookFilled: React.lazy(() => import('./ui/fill/BookFilled.js')),
  BookOpenFilled: React.lazy(() => import('./ui/fill/BookOpenFilled.js')),
  BroomFilled: React.lazy(() => import('./ui/fill/BroomFilled.js')),
  BuildingFilled: React.lazy(() => import('./ui/fill/BuildingFilled.js')),
  BusFilled: React.lazy(() => import('./ui/fill/BusFilled.js')),
  CalendarFilled: React.lazy(() => import('./ui/fill/CalendarFilled.js')),
  CalendarStarFilled: React.lazy(() => import('./ui/fill/CalendarStarFilled.js')),
  CalendarTimeFilled: React.lazy(() => import('./ui/fill/CalendarTimeFilled.js')),
  CameraFilled: React.lazy(() => import('./ui/fill/CameraFilled.js')),
  CarFilled: React.lazy(() => import('./ui/fill/CarFilled.js')),
  ChargerFilled: React.lazy(() => import('./ui/fill/ChargerFilled.js')),
  ChatBubbleFilled: React.lazy(() => import('./ui/fill/ChatBubbleFilled.js')),
  ChatboxFilled: React.lazy(() => import('./ui/fill/ChatboxFilled.js')),
  ClockFilled: React.lazy(() => import('./ui/fill/ClockFilled.js')),
  CloudDownloadFilled: React.lazy(() => import('./ui/fill/CloudDownloadFilled.js')),
  CloudUploadFilled: React.lazy(() => import('./ui/fill/CloudUploadFilled.js')),
  CoffeeFilled: React.lazy(() => import('./ui/fill/CoffeeFilled.js')),
  CompassFilled: React.lazy(() => import('./ui/fill/CompassFilled.js')),
  CreditCardFilled: React.lazy(() => import('./ui/fill/CreditCardFilled.js')),
  DisplayFilled: React.lazy(() => import('./ui/fill/DisplayFilled.js')),
  DollarFilled: React.lazy(() => import('./ui/fill/DollarFilled.js')),
  DoorOpenFilled: React.lazy(() => import('./ui/fill/DoorOpenFilled.js')),
  DrinkFilled: React.lazy(() => import('./ui/fill/DrinkFilled.js')),
  EditFilled: React.lazy(() => import('./ui/fill/EditFilled.js')),
  FirstAidFilled: React.lazy(() => import('./ui/fill/FirstAidFilled.js')),
  FlagFilled: React.lazy(() => import('./ui/fill/FlagFilled.js')),
  GlobeFilled: React.lazy(() => import('./ui/fill/GlobeFilled.js')),
  GridFilled: React.lazy(() => import('./ui/fill/GridFilled.js')),
  HeartFilled: React.lazy(() => import('./ui/fill/HeartFilled.js')),
  HelpFilled: React.lazy(() => import('./ui/fill/HelpFilled.js')),
  HotelFilled: React.lazy(() => import('./ui/fill/HotelFilled.js')),
  HourglassFilled: React.lazy(() => import('./ui/fill/HourglassFilled.js')),
  ImageFilled: React.lazy(() => import('./ui/fill/ImageFilled.js')),
  InfoCircleFilled: React.lazy(() => import('./ui/fill/InfoCircleFilled.js')),
  LikeFilled: React.lazy(() => import('./ui/fill/LikeFilled.js')),
  LocationFilled: React.lazy(() => import('./ui/fill/LocationFilled.js')),
  LocationPinFilled: React.lazy(() => import('./ui/fill/LocationPinFilled.js')),
  LockFilled: React.lazy(() => import('./ui/fill/LockFilled.js')),
  LoungeFilled: React.lazy(() => import('./ui/fill/LoungeFilled.js')),
  LuggageFilled: React.lazy(() => import('./ui/fill/LuggageFilled.js')),
  LuggageTrolleyFilled: React.lazy(() => import('./ui/fill/LuggageTrolleyFilled.js')),
  MailFilled: React.lazy(() => import('./ui/fill/MailFilled.js')),
  MapFilled: React.lazy(() => import('./ui/fill/MapFilled.js')),
  MaskFilled: React.lazy(() => import('./ui/fill/MaskFilled.js')),
  MealFilled: React.lazy(() => import('./ui/fill/MealFilled.js')),
  NeighbourhoodFilled: React.lazy(() => import('./ui/fill/NeighbourhoodFilled.js')),
  NotificationBellFilled: React.lazy(() => import('./ui/fill/NotificationBellFilled.js')),
  ParkingFilled: React.lazy(() => import('./ui/fill/ParkingFilled.js')),
  PersonRunningFilled: React.lazy(() => import('./ui/fill/PersonRunningFilled.js')),
  PhoneFilled: React.lazy(() => import('./ui/fill/PhoneFilled.js')),
  PlayFilled: React.lazy(() => import('./ui/fill/PlayFilled.js')),
  PrinterFilled: React.lazy(() => import('./ui/fill/PrinterFilled.js')),
  PuzzleFilled: React.lazy(() => import('./ui/fill/PuzzleFilled.js')),
  RoadFilled: React.lazy(() => import('./ui/fill/RoadFilled.js')),
  SanitizerFilled: React.lazy(() => import('./ui/fill/SanitizerFilled.js')),
  SeatFrontFilled: React.lazy(() => import('./ui/fill/SeatFrontFilled.js')),
  SeatSideFilled: React.lazy(() => import('./ui/fill/SeatSideFilled.js')),
  SendFilled: React.lazy(() => import('./ui/fill/SendFilled.js')),
  SettingsFilled: React.lazy(() => import('./ui/fill/SettingsFilled.js')),
  ShareFilled: React.lazy(() => import('./ui/fill/ShareFilled.js')),
  ShieldFilled: React.lazy(() => import('./ui/fill/ShieldFilled.js')),
  ShieldTickFilled: React.lazy(() => import('./ui/fill/ShieldTickFilled.js')),
  SkipFilled: React.lazy(() => import('./ui/fill/SkipFilled.js')),
  SmartphoneFilled: React.lazy(() => import('./ui/fill/SmartphoneFilled.js')),
  SosFilled: React.lazy(() => import('./ui/fill/SosFilled.js')),
  SparkFilled: React.lazy(() => import('./ui/fill/SparkFilled.js')),
  TShirtFilled: React.lazy(() => import('./ui/fill/TShirtFilled.js')),
  TaxiFilled: React.lazy(() => import('./ui/fill/TaxiFilled.js')),
  ThermometerFilled: React.lazy(() => import('./ui/fill/ThermometerFilled.js')),
  Ticket2Filled: React.lazy(() => import('./ui/fill/Ticket2Filled.js')),
  TicketFilled: React.lazy(() => import('./ui/fill/TicketFilled.js')),
  TicketTimeFilled: React.lazy(() => import('./ui/fill/TicketTimeFilled.js')),
  ToiletFilled: React.lazy(() => import('./ui/fill/ToiletFilled.js')),
  TrainFilled: React.lazy(() => import('./ui/fill/TrainFilled.js')),
  TransferFilled: React.lazy(() => import('./ui/fill/TransferFilled.js')),
  TrashcanFilled: React.lazy(() => import('./ui/fill/TrashcanFilled.js')),
  UserFilled: React.lazy(() => import('./ui/fill/UserFilled.js')),
  UsersFilled: React.lazy(() => import('./ui/fill/UsersFilled.js')),
  UsersMultipleFilled: React.lazy(() => import('./ui/fill/UsersMultipleFilled.js')),
  WalletFilled: React.lazy(() => import('./ui/fill/WalletFilled.js')),
  WheelchairFilled: React.lazy(() => import('./ui/fill/WheelchairFilled.js')),
  WifiFilled: React.lazy(() => import('./ui/fill/WifiFilled.js')),
  ZoomInFilled: React.lazy(() => import('./ui/fill/ZoomInFilled.js')),
  ZoomOutFilled: React.lazy(() => import('./ui/fill/ZoomOutFilled.js')),
  Affirm: React.lazy(() => import('./ui/payment/Affirm.js')),
  Amex: React.lazy(() => import('./ui/payment/Amex.js')),
  ApplePay: React.lazy(() => import('./ui/payment/ApplePay.js')),
  Cirrus: React.lazy(() => import('./ui/payment/Cirrus.js')),
  CreditCardBack: React.lazy(() => import('./ui/payment/CreditCardBack.js')),
  CreditCardFront: React.lazy(() => import('./ui/payment/CreditCardFront.js')),
  Diners: React.lazy(() => import('./ui/payment/Diners.js')),
  Discover: React.lazy(() => import('./ui/payment/Discover.js')),
  GPay: React.lazy(() => import('./ui/payment/GPay.js')),
  IDeal: React.lazy(() => import('./ui/payment/IDeal.js')),
  Maestro: React.lazy(() => import('./ui/payment/Maestro.js')),
  Mastercard: React.lazy(() => import('./ui/payment/Mastercard.js')),
  Paypal: React.lazy(() => import('./ui/payment/Paypal.js')),
  Visa: React.lazy(() => import('./ui/payment/Visa.js')),
  HappyFilled: React.lazy(() => import('./ui/reviews/HappyFilled.js')),
  Happy: React.lazy(() => import('./ui/reviews/Happy.js')),
  NeutralFilled: React.lazy(() => import('./ui/reviews/NeutralFilled.js')),
  Neutral: React.lazy(() => import('./ui/reviews/Neutral.js')),
  SadFilled: React.lazy(() => import('./ui/reviews/SadFilled.js')),
  Sad: React.lazy(() => import('./ui/reviews/Sad.js')),
  StarEmpty: React.lazy(() => import('./ui/reviews/StarEmpty.js')),
  StarFilled: React.lazy(() => import('./ui/reviews/StarFilled.js')),
  StarHalfFilled: React.lazy(() => import('./ui/reviews/StarHalfFilled.js')),
  FacebookFilled: React.lazy(() => import('./ui/socials/fill/FacebookFilled.js')),
  FramerFilled: React.lazy(() => import('./ui/socials/fill/FramerFilled.js')),
  GithubFilled: React.lazy(() => import('./ui/socials/fill/GithubFilled.js')),
  GitlabFilled: React.lazy(() => import('./ui/socials/fill/GitlabFilled.js')),
  InstagramFilled: React.lazy(() => import('./ui/socials/fill/InstagramFilled.js')),
  LinkedinFilled: React.lazy(() => import('./ui/socials/fill/LinkedinFilled.js')),
  PinterestFilled: React.lazy(() => import('./ui/socials/fill/PinterestFilled.js')),
  SlackFilled: React.lazy(() => import('./ui/socials/fill/SlackFilled.js')),
  TwitchFilled: React.lazy(() => import('./ui/socials/fill/TwitchFilled.js')),
  XFilled: React.lazy(() => import('./ui/socials/fill/XFilled.js')),
  YoutubeFilled: React.lazy(() => import('./ui/socials/fill/YoutubeFilled.js')),
  Facebook: React.lazy(() => import('./ui/socials/stroke/Facebook.js')),
  Framer: React.lazy(() => import('./ui/socials/stroke/Framer.js')),
  Github: React.lazy(() => import('./ui/socials/stroke/Github.js')),
  Gitlab: React.lazy(() => import('./ui/socials/stroke/Gitlab.js')),
  Instagram: React.lazy(() => import('./ui/socials/stroke/Instagram.js')),
  Linkedin: React.lazy(() => import('./ui/socials/stroke/Linkedin.js')),
  Pinterest: React.lazy(() => import('./ui/socials/stroke/Pinterest.js')),
  Slack: React.lazy(() => import('./ui/socials/stroke/Slack.js')),
  Twitch: React.lazy(() => import('./ui/socials/stroke/Twitch.js')),
  X: React.lazy(() => import('./ui/socials/stroke/X.js')),
  Youtube: React.lazy(() => import('./ui/socials/stroke/Youtube.js')),
  AlertCircle: React.lazy(() => import('./ui/stroke/AlertCircle.js')),
  AlertTriangle: React.lazy(() => import('./ui/stroke/AlertTriangle.js')),
  ArrowSquare: React.lazy(() => import('./ui/stroke/ArrowSquare.js')),
  Audio: React.lazy(() => import('./ui/stroke/Audio.js')),
  BarSquare: React.lazy(() => import('./ui/stroke/BarSquare.js')),
  Bar: React.lazy(() => import('./ui/stroke/Bar.js')),
  BookOpen: React.lazy(() => import('./ui/stroke/BookOpen.js')),
  Book: React.lazy(() => import('./ui/stroke/Book.js')),
  Broom: React.lazy(() => import('./ui/stroke/Broom.js')),
  Building: React.lazy(() => import('./ui/stroke/Building.js')),
  Bus: React.lazy(() => import('./ui/stroke/Bus.js')),
  CalendarStar: React.lazy(() => import('./ui/stroke/CalendarStar.js')),
  CalendarTime: React.lazy(() => import('./ui/stroke/CalendarTime.js')),
  Calendar: React.lazy(() => import('./ui/stroke/Calendar.js')),
  Camera: React.lazy(() => import('./ui/stroke/Camera.js')),
  Car: React.lazy(() => import('./ui/stroke/Car.js')),
  Charger: React.lazy(() => import('./ui/stroke/Charger.js')),
  ChatBubble: React.lazy(() => import('./ui/stroke/ChatBubble.js')),
  Chatbox: React.lazy(() => import('./ui/stroke/Chatbox.js')),
  Clock: React.lazy(() => import('./ui/stroke/Clock.js')),
  CloudDownload: React.lazy(() => import('./ui/stroke/CloudDownload.js')),
  CloudUpload: React.lazy(() => import('./ui/stroke/CloudUpload.js')),
  Coffee: React.lazy(() => import('./ui/stroke/Coffee.js')),
  Compass: React.lazy(() => import('./ui/stroke/Compass.js')),
  CreditCard: React.lazy(() => import('./ui/stroke/CreditCard.js')),
  Display: React.lazy(() => import('./ui/stroke/Display.js')),
  Dollar: React.lazy(() => import('./ui/stroke/Dollar.js')),
  DoorOpen: React.lazy(() => import('./ui/stroke/DoorOpen.js')),
  Drink: React.lazy(() => import('./ui/stroke/Drink.js')),
  Edit: React.lazy(() => import('./ui/stroke/Edit.js')),
  FirstAid: React.lazy(() => import('./ui/stroke/FirstAid.js')),
  Flag: React.lazy(() => import('./ui/stroke/Flag.js')),
  Globe: React.lazy(() => import('./ui/stroke/Globe.js')),
  Grid: React.lazy(() => import('./ui/stroke/Grid.js')),
  Heart: React.lazy(() => import('./ui/stroke/Heart.js')),
  Help: React.lazy(() => import('./ui/stroke/Help.js')),
  Hotel: React.lazy(() => import('./ui/stroke/Hotel.js')),
  Hourglass: React.lazy(() => import('./ui/stroke/Hourglass.js')),
  Image: React.lazy(() => import('./ui/stroke/Image.js')),
  InfoCircle: React.lazy(() => import('./ui/stroke/InfoCircle.js')),
  Like: React.lazy(() => import('./ui/stroke/Like.js')),
  LocationPin: React.lazy(() => import('./ui/stroke/LocationPin.js')),
  Location: React.lazy(() => import('./ui/stroke/Location.js')),
  Lock: React.lazy(() => import('./ui/stroke/Lock.js')),
  Lounge: React.lazy(() => import('./ui/stroke/Lounge.js')),
  LuggageTrolley: React.lazy(() => import('./ui/stroke/LuggageTrolley.js')),
  Luggage: React.lazy(() => import('./ui/stroke/Luggage.js')),
  Mail: React.lazy(() => import('./ui/stroke/Mail.js')),
  Map: React.lazy(() => import('./ui/stroke/Map.js')),
  Mask: React.lazy(() => import('./ui/stroke/Mask.js')),
  Meal: React.lazy(() => import('./ui/stroke/Meal.js')),
  Neighbourhood: React.lazy(() => import('./ui/stroke/Neighbourhood.js')),
  NotificationBell: React.lazy(() => import('./ui/stroke/NotificationBell.js')),
  Parking: React.lazy(() => import('./ui/stroke/Parking.js')),
  PersonRunning: React.lazy(() => import('./ui/stroke/PersonRunning.js')),
  Phone: React.lazy(() => import('./ui/stroke/Phone.js')),
  Play: React.lazy(() => import('./ui/stroke/Play.js')),
  Printer: React.lazy(() => import('./ui/stroke/Printer.js')),
  Puzzle: React.lazy(() => import('./ui/stroke/Puzzle.js')),
  Road: React.lazy(() => import('./ui/stroke/Road.js')),
  Sanitizer: React.lazy(() => import('./ui/stroke/Sanitizer.js')),
  SeatFront: React.lazy(() => import('./ui/stroke/SeatFront.js')),
  SeatSide: React.lazy(() => import('./ui/stroke/SeatSide.js')),
  Send: React.lazy(() => import('./ui/stroke/Send.js')),
  Settings: React.lazy(() => import('./ui/stroke/Settings.js')),
  Share: React.lazy(() => import('./ui/stroke/Share.js')),
  ShieldTick: React.lazy(() => import('./ui/stroke/ShieldTick.js')),
  Shield: React.lazy(() => import('./ui/stroke/Shield.js')),
  Skip: React.lazy(() => import('./ui/stroke/Skip.js')),
  Smartphone: React.lazy(() => import('./ui/stroke/Smartphone.js')),
  Sos: React.lazy(() => import('./ui/stroke/Sos.js')),
  Spark: React.lazy(() => import('./ui/stroke/Spark.js')),
  TShirt: React.lazy(() => import('./ui/stroke/TShirt.js')),
  Taxi: React.lazy(() => import('./ui/stroke/Taxi.js')),
  Thermometer: React.lazy(() => import('./ui/stroke/Thermometer.js')),
  Ticket2: React.lazy(() => import('./ui/stroke/Ticket2.js')),
  TicketTime: React.lazy(() => import('./ui/stroke/TicketTime.js')),
  Ticket: React.lazy(() => import('./ui/stroke/Ticket.js')),
  Toilet: React.lazy(() => import('./ui/stroke/Toilet.js')),
  Train: React.lazy(() => import('./ui/stroke/Train.js')),
  Transfer: React.lazy(() => import('./ui/stroke/Transfer.js')),
  Trashcan: React.lazy(() => import('./ui/stroke/Trashcan.js')),
  User: React.lazy(() => import('./ui/stroke/User.js')),
  UsersMultiple: React.lazy(() => import('./ui/stroke/UsersMultiple.js')),
  Users: React.lazy(() => import('./ui/stroke/Users.js')),
  Wallet: React.lazy(() => import('./ui/stroke/Wallet.js')),
  Wheelchair: React.lazy(() => import('./ui/stroke/Wheelchair.js')),
  Wifi: React.lazy(() => import('./ui/stroke/Wifi.js')),
  ZoomIn: React.lazy(() => import('./ui/stroke/ZoomIn.js')),
  ZoomOut: React.lazy(() => import('./ui/stroke/ZoomOut.js')),
  ArrowsDiagonal: React.lazy(() => import('./ui/stroke/miscellaneous/ArrowsDiagonal.js')),
  ArrowsHorizontal: React.lazy(() => import('./ui/stroke/miscellaneous/ArrowsHorizontal.js')),
  Customise: React.lazy(() => import('./ui/stroke/miscellaneous/Customise.js')),
  Dots: React.lazy(() => import('./ui/stroke/miscellaneous/Dots.js')),
  Download: React.lazy(() => import('./ui/stroke/miscellaneous/Download.js')),
  Hanger: React.lazy(() => import('./ui/stroke/miscellaneous/Hanger.js')),
  Language: React.lazy(() => import('./ui/stroke/miscellaneous/Language.js')),
  Loading: React.lazy(() => import('./ui/stroke/miscellaneous/Loading.js')),
  LogOut: React.lazy(() => import('./ui/stroke/miscellaneous/LogOut.js')),
  Menu: React.lazy(() => import('./ui/stroke/miscellaneous/Menu.js')),
  SortDown: React.lazy(() => import('./ui/stroke/miscellaneous/SortDown.js')),
  SortUp: React.lazy(() => import('./ui/stroke/miscellaneous/SortUp.js')),
  TimeDottedLine: React.lazy(() => import('./ui/stroke/miscellaneous/TimeDottedLine.js')),
  TimeFast: React.lazy(() => import('./ui/stroke/miscellaneous/TimeFast.js')),
  UnescoStatus: React.lazy(() => import('./ui/stroke/miscellaneous/UnescoStatus.js')),
  Upload: React.lazy(() => import('./ui/stroke/miscellaneous/Upload.js')),
  MinusFilled: React.lazy(() => import('./ui/symbols/fill/MinusFilled.js')),
  MultiplyFilled: React.lazy(() => import('./ui/symbols/fill/MultiplyFilled.js')),
  PercentageFilled: React.lazy(() => import('./ui/symbols/fill/PercentageFilled.js')),
  PlusFilled: React.lazy(() => import('./ui/symbols/fill/PlusFilled.js')),
  Minus: React.lazy(() => import('./ui/symbols/stroke/Minus.js')),
  Multiply: React.lazy(() => import('./ui/symbols/stroke/Multiply.js')),
  Percentage: React.lazy(() => import('./ui/symbols/stroke/Percentage.js')),
  Plus: React.lazy(() => import('./ui/symbols/stroke/Plus.js')),
  TextAlignCenter: React.lazy(() => import('./ui/text-alignment/TextAlignCenter.js')),
  TextAlignJustify: React.lazy(() => import('./ui/text-alignment/TextAlignJustify.js')),
  TextAlignLeft: React.lazy(() => import('./ui/text-alignment/TextAlignLeft.js')),
  TextAlignRight: React.lazy(() => import('./ui/text-alignment/TextAlignRight.js')),
  CloudyFilled: React.lazy(() => import('./ui/weather/CloudyFilled.js')),
  Cloudy: React.lazy(() => import('./ui/weather/Cloudy.js')),
  Drizzle: React.lazy(() => import('./ui/weather/Drizzle.js')),
  PartiallyCloudy: React.lazy(() => import('./ui/weather/PartiallyCloudy.js')),
  Rain: React.lazy(() => import('./ui/weather/Rain.js')),
  Snow: React.lazy(() => import('./ui/weather/Snow.js')),
  Storm: React.lazy(() => import('./ui/weather/Storm.js')),
  SunnyFilled: React.lazy(() => import('./ui/weather/SunnyFilled.js')),
  Sunny: React.lazy(() => import('./ui/weather/Sunny.js')),
  ThunderstormFilled: React.lazy(() => import('./ui/weather/ThunderstormFilled.js')),
  Thunderstorm: React.lazy(() => import('./ui/weather/Thunderstorm.js')),
  WeatherFilled: React.lazy(() => import('./ui/weather/WeatherFilled.js')),
  Weather: React.lazy(() => import('./ui/weather/Weather.js')),
  Windy: React.lazy(() => import('./ui/weather/Windy.js'))
};
var mapper_default = IconMap;

export { mapper_default as default };
